/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Components.Common {

    /**
     * Stops taps/clicks from reaching ancestor handlers, without using ng-click.
     *
     * ngTouch (lib/angular-touch.js) decorates away AngularJS's built-in ngClick app-wide and
     * replaces it with a tap-based version that fires on touchend and then calls
     * preventGhostClick(). That arms a global clickbuster which stopPropagation()s and
     * preventDefault()s the real click that follows. Any ng-click ANCESTOR therefore makes
     * descendants that depend on a genuine bubbling click - jQuery delegated handlers, native
     * listeners, focusing an input - unusable on touch devices, while desktop is unaffected.
     *
     * That makes ng-click="$event.stopPropagation();" self-defeating when it is used only to
     * shield a subtree from a clickable parent: it is itself an ng-click, so it arms the buster
     * over its own children. This directive does the same shielding with native listeners only,
     * so preventGhostClick() is never called and the click survives to reach the subtree.
     *
     * Both touch events must be stopped: touchend so no ancestor ng-click fires (that is what
     * arms the buster), and touchstart so an ancestor ng-click is not left holding stale tapping
     * state and its active class. Stopping them during the bubble phase is safe - the
     * clickbuster's own whitelist handler is capture-phase on $rootElement and has already run.
     *
     * First used for bug 135886 (Register Lot # typeahead and lot qty not interactive on
     * iPad/mobile) to replace an ng-click on the lot block inside the sale line's v-pane-header.
     */
    export class MeevoStopTapPropagation implements angular.IDirective {
        restrict = 'A';

        private static EVENTS = 'touchstart touchend touchcancel click';

        link = (scope: angular.IScope, element: JQuery) => {
            const stop = (event: JQueryEventObject) => {
                event.stopPropagation();
            };

            element.on(MeevoStopTapPropagation.EVENTS, stop);

            scope.$on('$destroy', () => {
                element.off(MeevoStopTapPropagation.EVENTS, stop);
            });
        };

        static factory(): angular.IDirectiveFactory {
            const directive = () => {
                return new MeevoStopTapPropagation();
            };
            directive.$inject = [];
            return directive;
        }
    }

    angular.module('meevo')
        .directive('meevoStopTapPropagation', MeevoStopTapPropagation.factory());
}
